import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { AppConfigContext } from '@infl-ts/util-app-config';
import { BlockWidthWrapper } from '@infl-ts/util-block-width-context';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, buttonClasses, linkClasses, Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import { useContext, useEffect, useRef } from 'react';
import { Tooltip } from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CannotPreviewContent = function CannotPreviewContent(_ref) {
  var sx = _ref.sx;
  return /*#__PURE__*/_jsx(BlockWidthWrapper, {
    "data-element": "BlockWidthWrapper",
    "data-component": "CannotPreviewContent",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsxs(Box, {
      sx: mergeSxProps({
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        py: 5
      }, sx),
      "data-element": "Box",
      "data-component": "CannotPreviewContent",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        sx: {
          textAlign: 'center'
        },
        "data-element": "Typography",
        "data-component": "CannotPreviewContent",
        "data-source-file": "index.tsx",
        children: "Can't preview this in Lens Mode"
      }), /*#__PURE__*/_jsx(Typography, {
        sx: {
          textAlign: 'center',
          mt: 0.5
        },
        "data-element": "Typography",
        "data-source-file": "index.tsx",
        children: "Clear your Lens session to view this content"
      })]
    })
  });
};

var disableAllChildren = function disableAllChildren(elem) {
  if (elem.children.length > 0) {
    pipe(Array.from(elem.children), A.map(function (elem) {
      elem.setAttribute('disabled', 'true');
      elem.setAttribute('onclick', 'return false');
      disableAllChildren(elem);
    }));
  }
};

var LensTooltip = function LensTooltip(_ref2) {
  var _mergeSxProps;

  var sx = _ref2.sx,
      children = _ref2.children;
  var wrapperRef = useRef(null);
  useEffect(function () {
    if (wrapperRef !== null && wrapperRef !== void 0 && wrapperRef.current) disableAllChildren(wrapperRef.current);
  }, [wrapperRef]);
  return /*#__PURE__*/_jsx(Tooltip, {
    disableFocusListener: true,
    arrow: true,
    title: "This can't be previewed in Lens Mode.",
    "data-element": "Tooltip",
    "data-component": "LensTooltip",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      ref: wrapperRef,
      sx: mergeSxProps((_mergeSxProps = {
        '& *': {
          pointerEvents: 'none'
        }
      }, _defineProperty(_mergeSxProps, "& .".concat(buttonClasses.root), {
        color: function color(t) {
          return t.palette.action.disabled;
        },
        boxShadow: 'none'
      }), _defineProperty(_mergeSxProps, "& .".concat(buttonClasses.contained), {
        backgroundColor: function backgroundColor(t) {
          return t.palette.action.disabledBackground;
        }
      }), _defineProperty(_mergeSxProps, "& .".concat(buttonClasses.outlined), {
        borderColor: function borderColor(t) {
          return t.palette.action.disabled;
        }
      }), _defineProperty(_mergeSxProps, "& .".concat(linkClasses.root), {
        color: function color(t) {
          return t.palette.action.disabled;
        }
      }), _defineProperty(_mergeSxProps, "color", function color(t) {
        return t.palette.action.disabled;
      }), _defineProperty(_mergeSxProps, "zIndex", 1), _mergeSxProps), sx),
      "data-element": "Box",
      "data-component": "LensTooltip",
      "data-source-file": "index.tsx",
      children: children
    })
  });
};

export var UnavailableInLens = function UnavailableInLens(_ref3) {
  var _ref3$tooltip = _ref3.tooltip,
      tooltip = _ref3$tooltip === void 0 ? false : _ref3$tooltip,
      _ref3$hideChildren = _ref3.hideChildren,
      hideChildren = _ref3$hideChildren === void 0 ? false : _ref3$hideChildren,
      customDisabledSx = _ref3.customDisabledSx,
      children = _ref3.children;

  var _useContext = useContext(AppConfigContext),
      activeLens = _useContext.modes.activeLens;

  if (!activeLens) return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
  return hideChildren ? null : tooltip ? /*#__PURE__*/_jsx(LensTooltip, {
    sx: customDisabledSx,
    children: children
  }) : /*#__PURE__*/_jsx(CannotPreviewContent, {
    sx: customDisabledSx
  });
};